import * as config from "./config.js";
import { triggerLogout } from "./authBridge";

const BASE = config.REST_SERVER_URL;
const originalFetch = window.fetch.bind(window);

let isRefreshing = false;
let waiters = [];
const subscribe = () => new Promise((resolve, reject) => waiters.push({ resolve, reject }));
const flush = (err) => { waiters.forEach(w => err ? w.reject(err) : w.resolve()); waiters = []; };

function urlOf(input) {
  return typeof input === "string" ? input : (input instanceof URL ? input.href : input.url);
}
function isOurApi(input) {
  return urlOf(input).startsWith(BASE);
}

function handleLogout() {
  triggerLogout();
}

async function refreshAccess() {
  const res = await originalFetch(`${BASE}/admin/new/refresh`, { method: "POST", credentials: "include" });
  if (!res.ok) throw new Error("refresh failed");
}

window.fetch = async function(input, init = {}, _retry = false) {
  // leave third-party / cross-origin requests completely alone
  if (!isOurApi(input)) return originalFetch(input, init);

  //const opts = { ...init, credentials: "include" };
  const opts = { ...init }; //, credentials: "include" };
  const res = await originalFetch(input, opts);

  if (res.status !== 401 || _retry || urlOf(input).includes("/admin/new/refresh")) {
    return res;
  }

  if (isRefreshing) {
    await subscribe();
    return window.fetch(input, init, true);
  }

  isRefreshing = true;
  try {
    await refreshAccess();
    flush(null);
    return window.fetch(input, init, true);
  } catch (err) {
    flush(err);
    handleLogout();
    throw err;
  } finally {
    isRefreshing = false;
  }
};
